export default `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 23.0.4, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve">
<style type="text/css">
	.st0{clip-path:url(#SVGID_2_);}
</style>
<g fill=currentColor>
	<defs>
		<rect id="SVGID_1_" x="1.55" y="2.21" width="20.85" height="19.85"/>
	</defs>
	<clipPath id="SVGID_2_">
		<use xlink:href="#SVGID_1_"  style="overflow:visible;"/>
	</clipPath>
	<g class="st0">
		<path class="st1" d="M11.9,6.71H4.05v0.76h7.85V6.71z"/>
		<path class="st1" d="M11.9,9.71H4.05v0.76h7.85V9.71z"/>
		<path class="st1" d="M11.9,12.71H4.05v0.76h7.85V12.71z"/>
		<path class="st1" d="M14.4,6.21v-4H1.55v19.85h4h4.85h3.15h0.85h8V6.21H14.4z M6.4,21.21v-4.15h3.15v4.15H6.4z M13.55,21.21H10.4
			v-5H5.55v5H2.4V3.06h11.15v3.15V21.21z M21.55,21.21H14.4v-3.67h5.64v-0.83H14.4v-2.17h5.64v-0.83H14.4v-2.17h5.64v-0.83H14.4
			V7.06h7.15V21.21z"/>
	</g>
</g>
</svg>
`;
